import React from 'react'

import useMediaQuery from '../../hooks/useMediaQuery'

import { Root, Scroll } from './brands.styles.js'

import brand1 from './brands/brand1.png'
import brand2 from './brands/brand2.png'
import brand3 from './brands/brand3.png'
import brand4 from './brands/brand4.png'
import brand5 from './brands/brand5.png'
import brand6 from './brands/brand6.png'
import brand7 from './brands/brand7.png'
import brand8 from './brands/brand8.png'
import brand9 from './brands/brand9.png'

const list = [
  brand1,
  brand5,
  brand2,
  brand3,
  brand4,
  brand9,
  brand6,
  brand7,
  brand8
]

const Brands = () => {
  const isTablet = useMediaQuery('(max-width: 1540px)')
  return (
    <Root>
      <Scroll>
        <span>As Seen On...</span>
        {(isTablet ? [...list, ...list] : list).map(src => (
          <img src={src} />
        ))}
      </Scroll>
    </Root>
  )
}

export default Brands
